import { iconService } from '@/services/IconService';
import { CONSTANTS } from '@/config/constants';
import { URLShortner } from '@/models';

// chars removed from original table -> ` ´ ^ ~ ¨ Ç ç
const REG_EXP_INVALID_CHARACTERS = /[^A-Z0-9 "'!@#$%&*\-+=_\/,.;:<>(){}?]/gi;

/**
 * Returns the new text without the token or link on immediate left.
 * If returns null implies that there is no token or link on the left.
 */
export function removeTokenOrLinkOnLeft(text: string, position: number) {
  const subText = text.substring(0, position);
  const textSplited = subText.split(' ');
  const lastPhrase = textSplited.pop();
  const tokens = getTokenOrLinksOnTheEnd(lastPhrase as string);
  if (tokens && tokens.length) {
    return [...textSplited, text.slice(position + 1) || ''].join(' ');
  }
  return null;
}

export function hasTokenOrLinkOnLeft(text: string, position: number) {
  const subText = text.substring(0, position);
  const textSplited = subText.split(' ');
  const lastPhrase = textSplited.pop();
  const tokens = getTokenOrLinksOnTheEnd(lastPhrase as string);
  if (tokens && tokens.length) {
    return tokens[0];
  }
  return null;
}

export function parseCampaignEditableText(text: string, shortLinks: URLShortner[] = []) {
  let newText = text;
  newText = replaceTokens(newText);
  newText = replaceWhatsAppLinks(newText, shortLinks.filter((link) => (
    link.destinationUrl.match(new RegExp(`https://wa.me/`, 'gi'))
  )) || []);
  newText = replaceNormalLinks(newText, shortLinks.filter((link) => (
    !link.destinationUrl.match(new RegExp(`https://wa.me/`, 'gi'))
  )));

  return newText;
}

function getTokenOrLinksOnTheEnd(text: string) {
  const matches = text.match(
    new RegExp(`.*\{\{([a-z|A-Z|0-9]+?)\}\}$|.*${CONSTANTS.smsShortLinkPrefix}\[a-z|A-Z|0-9]{10}$`, 'gi'),
  );
  return matches && matches.length && matches[0];
}

function replaceWhatsAppLinks(text: string, whatsLinks: URLShortner[]) {
  let newText = text;
  for (const link of whatsLinks) {
    newText = newText.replace(
      new RegExp(`(${CONSTANTS.smsShortLinkPrefix}${link.objectId})`, 'gi'),
      `<a contenteditable="false" href="$1" target="_blank" class="dib phone__token_link">$1</a>`,
    );
  }
  return newText;
}

function replaceNormalLinks(text: string, links: URLShortner[]) {
  let newText = text;
  for (const link of links) {
    newText = newText.replace(
      new RegExp(`(${CONSTANTS.smsShortLinkPrefix}${link.objectId})`, 'gi'),
      `<a contenteditable="false" href="$1" target="_blank" class="dib phone__token_link">$1</a>`,
    );
  }
  return newText;
}

function replaceTokens(text: string) {
  return text.replace(/(?<!{){{([^{}]*)}}(?!})/gi,
    `<span contenteditable="false" class="dib phone__token">{{$1}}</span>`);
}

export function normalizeOnPasteText(event: any) {
  event.preventDefault();
  let finalText = '';
  const text: string = (event.originalEvent || event).clipboardData.getData('text/plain');
  for (const char of text) {
    if (!char.match(REG_EXP_INVALID_CHARACTERS)) {
      finalText += char;
    }
  }
  document.execCommand('insertHTML', false, finalText);
  return finalText;
}

export function keyEventHasSpecialCharacters(event: any) {
  return event.data && event.data.match(REG_EXP_INVALID_CHARACTERS);
}

export function getTokensFromText(text: string = '') {
  return text.match(
    new RegExp(`\{\{(.+?)\}\}|${CONSTANTS.smsShortLinkPrefix}\[a-z|A-Z|0-9]{10}`, 'gi'),
  ) || [];
}
